module.exports = __webpack_public_path__ + "img/money-arrow.9780493c.svg";